import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { career } from '../data/profile';
import { SectionHeading } from './SectionHeading';
export function CareerTimeline() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="career" className="w-full scroll-mt-20 border-y border-navy/10 bg-white py-20 lg:py-28" aria-labelledby="career-heading" data-id="element-9" data-mp="3ah3r7nuv2c56">
      <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-10" data-mp="3jggzid790uob">
        <SectionHeading id="career-heading" eyebrow="Section 03 · Career & Leadership" title="Executive Career Progression" data-id="element-11" data-mp="3jexfqcmdw1hs" />

        <ol className="mt-14 relative border-l border-navy/15 pl-8 sm:pl-12" data-id="element-12" data-mp="3t5ifw4hphe2t">
          {career.map((entry, i) => {
          const isOpen = openIndex === i;
          return <li key={entry.organization} className="relative pb-10 last:pb-0" data-id="element-13" data-mp="612jnmtu58u0" data-mpi={i}>
                <span className={`absolute -left-[41px] top-6 flex h-4 w-4 items-center justify-center border-2 sm:-left-[57px] ${isOpen ? 'border-gold bg-gold' : 'border-navy/30 bg-white'}`} aria-hidden="true" data-id="element-14" data-mp="1x2f1ov2fo4rl" />
                <motion.div initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.45
            }} className={`border bg-canvas shadow-card transition-colors ${isOpen ? 'border-navy/20' : 'border-navy/10'}`} data-id="element-15" data-mp="1i6z1e8b9fcmr">
                  <h3 data-id="element-16" data-mp="21279h5k066vw">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`career-panel-${i}`} className="flex w-full flex-col gap-4 px-6 py-6 text-left sm:flex-row sm:items-center sm:justify-between sm:gap-8" data-id="element-17" data-mp="2yje57p857ba1">
                      <span className="flex-1" data-id="element-18" data-mp="i5vlunwvdupu">
                        <span className="block font-display text-[11px] font-bold uppercase tracking-[0.2em] text-gold-dark" data-id="element-19" data-mp="i52ogdjswhkd">
                          {entry.organization}
                        </span>
                        <span className="mt-2 block font-display text-xl font-bold text-navy" data-id="element-20" data-mp="93cnag04a49e">
                          {entry.role}
                        </span>
                      </span>
                      <span className="flex items-center gap-4" data-id="element-21" data-mp="3vdox8gsez8wm">
                        <span className="whitespace-nowrap border border-navy/15 bg-white px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-navy-steel" data-id="element-22" data-mp="45b31rqyfywc">
                          {entry.period}
                        </span>
                        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-navy-steel transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-23" data-mp="1yj2jpb7pbj1a" />
                      </span>
                    </button>
                  </h3>

                  <AnimatePresence initial={false} data-id="element-24" data-mp="3o07mu92wh3oo">
                    {isOpen && <motion.div id={`career-panel-${i}`} key="panel" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: [0.22, 1, 0.36, 1]
                }} className="overflow-hidden" data-id="element-25" data-mp="5lyka5oef94z">
                        <ul className="space-y-3 border-t border-navy/10 px-6 py-6" data-id="element-26" data-mp="2cdfzu44lfhjc">
                          {entry.impact.map(point => <li key={point} className="flex gap-3 text-sm leading-relaxed text-navy-steel/90" data-id="element-27" data-mp="13fpw838a9wgl">
                              <span className="mt-[7px] h-1.5 w-1.5 shrink-0 bg-gold" aria-hidden="true" data-id="element-28" data-mp="1dg08nlmhuzup" />
                              {point}
                            </li>)}
                        </ul>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}